// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"XS473","iconButton":"_1LO6U","iconSuccess":"_1kZxI","success-icon":"YSdej","container":"KPkDq"};